import { Stack } from '@chakra-ui/react';
import { AddConnectorCard, BackofficeConnectorCard } from '@main/integrations/frontend';

import { useOrgIntegrations } from '../integrations/org-integrations';

export const IntegrationsTab = ({ orgId }: { orgId: string }) => {
  const {
    orgIntegrations,
    insertOrgIntegration,
    setOrgIntegrationDisabled,
    setOrgIntegrationConfigurableByUser,
    setOrgIntegrationConfig,
    getOrgIntegrationConfigState,
    deleteOrgIntegration,
  } = useOrgIntegrations({ orgId });

  return (
    <Stack spacing="3">
      {orgIntegrations?.map((orgIntegration) => {
        return (
          <BackofficeConnectorCard
            key={orgIntegration.id}
            providerName={orgIntegration.integration.name}
            connectorName={orgIntegration.name ?? undefined}
            authName={orgIntegration.auth_name}
            controlsCount={orgIntegration.usage_stats?.controls_count ?? 0}
            evidenceCount={orgIntegration.usage_stats?.evidence_count ?? 0}
            configPersistence={{
              load: async () => getOrgIntegrationConfigState(orgIntegration.id),
              save: async (input) => setOrgIntegrationConfig(orgIntegration.id, input),
            }}
            isDisabled={orgIntegration.disabled ?? true}
            isConfigurableByUser={orgIntegration.is_configurable_by_user ?? false}
            onDisabledChange={(disabled) => {
              setOrgIntegrationDisabled(orgIntegration.id, disabled);
            }}
            onConfigurableByUserChange={(isConfigurableByUser) => {
              setOrgIntegrationConfigurableByUser(orgIntegration.id, isConfigurableByUser);
            }}
            onDelete={() => {
              deleteOrgIntegration(orgIntegration.id);
            }}
          />
        );
      })}

      <AddConnectorCard
        onAdd={async ({ providerName, connectorName, authName }) => {
          await insertOrgIntegration(providerName, connectorName, authName);
        }}
      />
    </Stack>
  );
};
